import React from 'react';
import { withTranslation } from 'react-i18next/hooks';

import theme from '../../../theme';

import {Button} from '@material-ui/core';
import {Grid, Container, Box} from '@material-ui/core';

//import {Tab, Tabs} from '@material-ui/core';
//import {TabPanel} from '../../../components/TabPanel'

//import {ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails} from '@material-ui/core';
//import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import {ApplicationBar} from '../../../components/ApplicationBar';

//import Logo from '../../components/Logo';

//import {TabbedMenu} from './TabbedMenu';

import {Dialog} from '../../../components/Dialog';
import { ServerLinksList } from './ServerLinksList';
import { getObjectByID } from '../../../api/helpers';
import { ServerLinkDialog } from './ServerLinkDialog';
import { DATA_OP_TYPE } from '../../api/ServerApi';
import { ServerGroupMapList } from './ServerGroupMapList';
import { VersionUptimeSmall } from '../../../FleetStatistics/pages/ServerMonitor/VersionUptime';
import { TabbedMenu } from './TabbedMenu';
import { LocalGroupsList } from './LocalGroupsList';
import { ExternalGroupsList } from './ExternalGroupsList';



class ServerLinks_ extends React.Component {

    constructor(props){

        super()

        //console.log('ServerLinks_ constructor')
        //console.log(this.props)

        this.state = {
            serverSettings: props.serverSettings,
            serverLinkDialog:{
                open: false,
                serverLink: null
            },
            selectedServerID: null,
            selectedServer: null,

            selectedLocalGroup: null,

            selectedTab: 'external_servers'
        }

        this.handleButtonCancel = this.handleButtonCancel.bind(this)
        this.handleButtonSave = this.handleButtonSave.bind(this)

        this.handleServerLinkContextMenu = this.handleServerLinkContextMenu.bind(this)
        this.handleServerLinkDialog = this.handleServerLinkDialog.bind(this)
        this.handleSrvLinkControl = this.handleSrvLinkControl.bind(this)

        this.handleAction = this.handleAction.bind(this)

        this.handleTabClick = this.handleTabClick.bind(this)

        props.onAction({type: 'SRV_LINK_CONTROL_REGISTER_CALLBACK', callback: this.handleSrvLinkControl})

        this.queryServerSettings(props)

    }

    queryServerSettings(props){

        props.onAction({
            type: 'QUERY_SERVER_SETTINGS',
            callback: this.queryServerSettingsCallback.bind(this)
        })

        /*
        this.api.queryGetServerSettings((serverSettings) => {
            if (this.state.externalServersEditor) {
                console.log('setState externalServersEditor')
                console.log(serverSettings)
                this.setState({
                    externalServersEditor: {
                        open: true,
                        serverSettings: serverSettings
                    }
                })
            }
        })  */

    }

    queryServerSettingsCallback(serverSettings){
        //console.log('queryServerSettingsCallback')
        //console.log(serverSettings)
        //console.log(this.state)

        this.setState({serverSettings: serverSettings})
    }

    /*
    componentDidUpdate(){
        
        if(!this.props.serverSettings) return

        if(this.state.serverSettings) return

        alert('componentDidUpdate')
        console.log('componentDidUpdate')
        console.log(this.props.serverSettings)
        console.log(this.state.serverSettings)

        if(this.props.serverSettings){
            console.log('setstate')
            console.log({serverSetting: this.props.serverSettings})
            this.setState({serverSetting: this.props.serverSettings})
        } 
        
    }
    */

    handleTabClick(tab){
        this.setState({
            selectedTab: tab, 
            loadExternalGroups: null
        });
    }


    findExternalServerIndex(ID, linkedServers){

        //console.log('findExternalServerIndex ' + ID)

        if(!linkedServers) linkedServers = this.state.serverSettings.LinkedServers 

        if(!linkedServers) return null

        const index = linkedServers.findIndex(item=>item.ServerLink['ID']===ID)
        return index>=0 ? index : null
    }

    findExternalServer(ID, linkedServers){

        //console.log('findExternalServer ' + ID)

        if(!linkedServers) linkedServers = this.state.serverSettings.LinkedServers

        if(!linkedServers) return null

        const index = this.findExternalServerIndex(ID, linkedServers)

        //console.log('index ' + index)

        return index!==null ? linkedServers[index] : null
    }

    handleButtonCancel(){

        this.props.onAction({type: 'SRV_LINK_CONTROL_REGISTER_CALLBACK', callback: null})

        this.props.onAction({type:'EXTERNAL_SERVERS_EDITOR_CLOSE'})
        
    }

    handleButtonSave(){
        //alert('todo apply settings')

        this.props.onAction({type: 'EXTERNAL_SERVERS_EDITOR_UPDATE', serverSettings: this.state.serverSettings })

        //EXTERNAL_SERVERS_EDITOR_UPDATE
    }

    handleServerLinkContextMenu(menu, linkID){

        switch(menu){

            case 'SERVER_LINK_EDITOR_OPEN_ADD':{

                let serverLink = {
                    Primary: true,
                    ID: 'AAAAAAAAAAAAAAAAAAAAAA==',
                    LinkState: 1,
                    IPEndpoint: '',
                    ExternalName: 'External Server',
                    ExternalLogin: '',
                    ExternalPassword: '',
                    LocalName: '',
                    LocalLogin: '',
                    ConnectState: 0,
                    LoginResponse: 0
                }


                this.setState({serverLinkDialog:{
                    open: true,
                    serverLink: serverLink,
                    opType: DATA_OP_TYPE.OP_ADD
                }})

                break
            }

            case 'SERVER_LINK_EDITOR_OPEN_EDIT':{

                let externalServer = this.findExternalServer(linkID)//, this.state.serverSettings.LinkedServers

                //console.log('serverLink '+linkID)
                //console.log(externalServer.ServerLink)
                //console.log(this.state.serverSettings.LinkedServers)
                
                
                this.setState({serverLinkDialog:{
                    open: true,
                    serverLink: externalServer.ServerLink,
                    opType: DATA_OP_TYPE.OP_CHANGE
                }})
                
                break
            }

            case 'SERVER_LINK_DELETE':{
                let externalServer = this.findExternalServer(linkID)//, this.state.serverSettings.LinkedServers

                //console.log('SERVER_LINK_DELETE')
                //console.log('externalServer')
                //console.log(externalServer)

                let action = {
                    type: 'SERVER_LINK_DELETE',
                    externalServer: externalServer,
                    //serverLink: externalServer.ServerLink,
                    opType: DATA_OP_TYPE.OP_REMOVE
                }
                //console.log(menu)
                //console.log(action)

                this.props.onAction(action)
                break
            }
                

            default:
                alert(menu)
        }

    }

    handleAction(action){

        //console.log('handleAction ServerLinks')
        //console.log(action)

        switch(action.type){

            case 'GET_EXTERNAL_SERVER':{

                let externalServer = this.findExternalServer(action.externalServerID)

                return externalServer
            }

            case 'SELECT_CURRENT_SERVER':{
                    let externalServer = this.findExternalServer(action.externalServerID)

                    console.log('externalServer')
                    console.log(externalServer)

                    this.setState({
                        selectedServerID: externalServer ? action.externalServerID : null,
                        selectedServer: externalServer
                    })

                break
            }

            case 'SET_EXTERNAL_SERVER_ID':{

                break
            }

            case 'SET_LOCAL_NETWORK_ID':{
                let server = this.state.selectedServer

                server.GroupMap[action.index].LocalNetworkId = action.value

                this.setState({selectedServer: server})

                break
            }

            case 'SET_EXTERNAL_NETWORK_ID':
            case 'SET_REMOTE_NETWORK_ID':{
                let server = this.state.selectedServer

                server.GroupMap[action.index].ExternalNetworkId = action.value

                this.setState({selectedServer: server})

                break
            }

            case 'SET_LOCAL_GROUP_ID':{

                let server = this.state.selectedServer

                //console.log('SET_LOCAL_GROUP_ID server')
                //console.log(server)

                let localNetworkId = server.GroupMap[action.index].LocalNetworkId

                let checkExist = false
                server.GroupMap.forEach((groupMap, index) => {
                    if(index!==action.index &&  groupMap.LocalNetworkId===localNetworkId && groupMap.LocalGroupId===action.value){
                        checkExist = true
                        //console.log('check exists: '+ index )
                    }
                })

                if(!checkExist) {
                    //console.log('set GroupMap LocalGroupId '+action.value)
                    server.GroupMap[action.index].LocalGroupId = action.value
                }

                this.setState({selectedServer: server})

                break
            }

            case 'SET_EXTERNAL_GROUP_ID':{

                let server = this.state.selectedServer

                //console.log('SET_LOCAL_GROUP_ID server')
                //console.log(server)

                let externalNetworkId = server.GroupMap[action.index].ExternalNetworkId

                let checkExist = false
                server.GroupMap.forEach((groupMap, index) => {
                    if(index!==action.index &&  groupMap.ExternalNetworkId===externalNetworkId && groupMap.ExternalGroupId===action.value){
                        //checkExist = true

                        server.GroupMap[index].ExternalGroupId = null

                        //console.log('check exists: '+ index )
                    }
                })

                if(!checkExist) {
                    //console.log('set GroupMap LocalGroupId '+action.value)
                    server.GroupMap[action.index].ExternalGroupId = action.value
                }

                this.setState({selectedServer: server})

                break
            }


            case 'GROUP_MAP_DELETE':{
                let server = this.state.selectedServer

                let externalServer = this.findExternalServer(action.externalServerID)
                externalServer.GroupMap.splice(action.index, 1)

                this.setState({selectedServer: server})
                break
            }

            case 'GROUP_MAP_ADD':{

                let server = this.state.selectedServer

                server.GroupMap.push({
                    ExternalServerId: server.ServerLink.ID,
                    ExternalGroupId: null,
                    ExternalNetworkId: null,
                    LocalNetworkId: null,
                    LocalGroupId: null
                })

                this.setState({selectedServer: server})

                break
            }

            case 'LOCAL_GROUP_SELECT':{

                //console.log('handle LOCAL_GROUP_SELECT')
                //console.log(action)

                this.setState({selectedLocalGroup: action.localGroup})

                break
            }

            case 'REGISTER_LOAD_EXTERNAL_GROUPS_CALLBACK':{
                this.setState({
                    loadExternalGroups: action.callback
                });
                break
            }

            default: alert(action.type)

        }
        
    }

    handleServerLinkDialog(action){
        
        //console.log('handleServerLinkDialog')
        //console.log(action)

        switch(action.type){
            case 'SERVER_LINK_DIALOG_CLOSE':{
                this.setState({serverLinkDialog:{
                    open: false,
                    serverLink: null
                }})
                break
            }

            case 'SERVER_LINK_SAVE':{

                let externalServer = null


                switch(action.opType){
                    case DATA_OP_TYPE.OP_ADD:
                        externalServer = {
                            ServerLink: action.serverLink,
                            RemoteServerObjects: {
                                DispatcherID: "AAAAAAAAAAAAAAAAAAAAAA==",
                                Networks: []
                            },
                            LocalServerObjects: {
                                DispatcherID: "AAAAAAAAAAAAAAAAAAAAAA==",
                                Networks: []
                            },
                            GroupMap: []
                        }

                        break

                    case DATA_OP_TYPE.OP_CHANGE:
                        externalServer = this.findExternalServer(action.serverLink.ID)

                        if(externalServer) externalServer.ServerLink = action.serverLink

                        break
                }

                action.externalServer = externalServer

                //console.log(action)
                this.props.onAction(action)
                break
            }

            case 'CONFIRM_DIALOG':
            case 'ALERT_DIALOG':
                this.props.onAction(action)
                break

            default:
                alert(action.type)
        }

    }


    handleSrvLinkControl(externalServer, opType){
        //alert('handleSrvLinkControl ' +opType)

        //console.log('handleSrvLinkControl ' +opType)

        let serverSettings = this.state.serverSettings


        switch(opType){
            case DATA_OP_TYPE.OP_INITIALIZE:
            case DATA_OP_TYPE.OP_ADD:
                //console.log('this.state.serverSettings.LinkedServers')
                //console.log(serverSettings.LinkedServers)
                serverSettings.LinkedServers.push(externalServer)
                break

            case DATA_OP_TYPE.OP_CHANGE:
                const index =  this.findExternalServerIndex(externalServer.ServerLink.ID)
                if(index!==null) serverSettings.LinkedServers[index] = externalServer;
                break 

            case DATA_OP_TYPE.OP_REMOVE:{
                const index = this.findExternalServerIndex(externalServer.ServerLink.ID)
                //console.log('DATA_OP_TYPE.OP_REMOVE')
                //console.log(externalServer)
                //console.log(externalServer.ServerLink.ID)
                //console.log(index)

                if(index!==null) serverSettings.LinkedServers.splice(index, 1)
                break                
            }

            default:
                const msg = 'Operation case not defined handleSrvLinkControl: ' + opType + ', see console log for more details'
                console.error(msg)

        }

        this.setState({serverSettings: serverSettings})

    }


    render(){
        const {t} = this.props

        let statusMessage = ""

        //console.log('render ServerLinks')
        //console.log(this.props)

        //console.log('this.state.serverSettings')
        //console.log(this.state.serverSettings)

        //let uptime = this.props.statisticsOverview
        let version = this.props.onAction({
            type: 'GET_VERSION'
        })
        //alert(version)
        let uptime = {Version: version, UpTime: null}


        return(
            <Grid item xs={12} style={{height:'100vh'}}>

                <ApplicationBar user={this.props.user} onAction={this.handleAction}>
                    <VersionUptimeSmall data={uptime}></VersionUptimeSmall>
                </ApplicationBar>

                <Grid container key="1" justifyContent="flex-start" spacing={0} 
                    style={{height:'83%', borderTop:'1px solid '+theme.palette.border.dialog}} >
                    <Grid xs={12} item style={{}}>
                        <Container height="100vh" style={{padding:0, paddingTop: '1em'}}>

                            <Dialog width="xl" variant="h6" align="left" title={t('ExternalServers')} style={{}}>

                                <Box textAlign="left" style={{paddingBottom: '1em'}}>
                                    <TabbedMenu
                                        selected={this.state.selectedTab} 
                                        onClick={this.handleTabClick}
                                        />
                                </Box>


                                {this.state.selectedTab=='external_servers'?(
                                    
                                    <ExternalLinksTab
                                        serverSettings={this.state.serverSettings} 
                                        currentServerID={this.state.selectedServerID}
                                        currentServer={this.state.selectedServer}
                                        onSeverLinkContextMenu={this.handleServerLinkContextMenu}
                                        onAction={this.handleAction}
                                        onButtonSave={this.handleButtonSave}
                                        onButtonCancel={this.handleButtonCancel} 
                                        t={this.props.t}
                                    />
                                    
                                ):null}


                                {this.state.selectedTab=='local_groups'?(
                                    
                                    <LocalGroupsTab
                                        serverSettings={this.state.serverSettings} 
                                        //currentServerID={this.state.selectedServerID}
                                        //currentServer={this.state.selectedServer}

                                        selectedLocalGroup={this.state.selectedLocalGroup}

                                        //loadExternalGroups = {this.state.loadExternalGroups}

                                        //onSeverLinkContextMenu={this.handleServerLinkContextMenu}
                                        onAction={this.handleAction}
                                        onButtonSave={this.handleButtonSave}
                                        onButtonCancel={this.handleButtonCancel} 
                                        t={this.props.t}
                                    
                                    />
                                    
                                ):null}

{/*

                                <Box textAlign="left" style={{paddingBottom: '1em'}}>

                                    {this.state.serverSettings ? (
                                    <ServerLinksList 
                                        linkedServers={this.state.serverSettings.LinkedServers} 
                                        currentServerID={this.state.selectedServerID}
                                        onContextMenu={this.handleServerLinkContextMenu}
                                        onAction={this.handleAction}
                                    />): null}

                                </Box>
                                <Box textAlign="center" style={{}}>
                                    <Button variant="contained" color="primary" 
                                        onClick={this.handleButtonSave.bind(this)} 
                                        style={{margin: '0 0.4em 1em'}}>{t('Apply')}</Button>
                                    <Button variant="contained" color="inherit"
                                        onClick={this.handleButtonCancel.bind(this)} 
                                        style={{margin: '0 0.4em 1em'}} >{t('Close')}</Button>
                                </Box>

                                <Box textAlign="left" style={{paddingBottom: '1em'}}>

                                    <ServerGroupMapList 
                                        currentServer={this.state.selectedServer} 
                                        onAction={this.handleAction}
                                    />

                                </Box>

                                <Box textAlign="center" style={{}}>
                                    <Button variant="contained" color="primary" 
                                        onClick={this.handleButtonSave.bind(this)} 
                                        style={{margin: '0 0.4em 1em'}}>{t('Apply')}</Button>

                                    <Button variant="contained" color="inherit"
                                        onClick={this.handleButtonCancel.bind(this)} 
                                        style={{margin: '0 0.4em 1em'}} >{t('Close')}</Button>
                                </Box>
*/}

                            </Dialog>

                        </Container>
                    </Grid>
                </Grid>
                <Grid xs={12} key="2" item style={{height:'3em'}}>
                    {statusMessage}{/*Server Status*/}
                </Grid>


                {this.state.serverLinkDialog && this.state.serverLinkDialog.open ? (

                    <ServerLinkDialog {...this.state.serverLinkDialog}
                        onAction={this.handleServerLinkDialog}/>

                ):null}


            </Grid>

        );


    }
    

}


class ExternalLinksTab extends React.Component {

    render(){

        const {t} = this.props

        return (
        <>

            <Box textAlign="left" style={{paddingBottom: '1em'}}>

                {this.props.serverSettings ? (
                <ServerLinksList 
                    linkedServers={this.props.serverSettings.LinkedServers} 
                    currentServerID={this.props.currentServerID}
                    onContextMenu={this.props.onSeverLinkContextMenu}
                    onAction={this.props.onAction}
                />): null}

            </Box>

            <Box textAlign="center" style={{}}>
                <Button variant="contained" color="primary" 
                    onClick={this.props.onButtonSave.bind(this)} 
                    style={{margin: '0 0.4em 1em'}}>{t('Apply')}</Button>
                <Button variant="contained" color="inherit"
                    onClick={this.props.onButtonCancel} 
                    style={{margin: '0 0.4em 1em'}} >{t('Close')}</Button>
            </Box>


            <Box textAlign="left" style={{paddingBottom: '1em'}}>

                <ServerGroupMapList 
                    serverSettings={this.props.serverSettings}
                    currentServer={this.props.currentServer} 
                    onAction={this.props.onAction}
                />

            </Box>



            <Box textAlign="center" style={{}}>
                <Button variant="contained" color="primary" 
                    onClick={this.props.onButtonSave.bind(this)} 
                    style={{margin: '0 0.4em 1em'}}>{t('Apply')}</Button>
                <Button variant="contained" color="inherit"
                    onClick={this.props.onButtonCancel} 
                    style={{margin: '0 0.4em 1em'}} >{t('Close')}</Button>
            </Box>

        </>
        )

    }

}


class LocalGroupsTab extends React.Component {

    getExternalGroupsList(serverSettings, localNetworkID, localGroupID){

        let externalGroupList = []

        //alert('getExternalGroupsList')
        //console.log('getExternalGroupsList '+localNetworkID+ ' ' +localGroupID+ ' ************************')
        //console.log(serverSettings)

        serverSettings.LinkedServers.forEach(linkedServer=>{

            linkedServer.GroupMap.forEach((groupMap, index) => {

                if(groupMap.LocalNetworkId==localNetworkID && groupMap.LocalGroupId==localGroupID){

                    externalGroupList.push({
                        ExternalServerId: linkedServer.ServerLink.ID,
                        ExternalGroupId: groupMap.ExternalGroupId,
                        ExternalNetworkId: groupMap.ExternalNetworkId,
                        groupMapIndex: index
                    })

                }

            })

        })

        console.log(externalGroupList)

        return externalGroupList

    }

    getExternalServers(serverSettings){

        console.log('getExternalServers()')

        let externalServers = []

        serverSettings.LinkedServers.forEach(linkedServer=>{
            console.log(linkedServer.ServerLink)
            externalServers.push({
                ID: linkedServer.ServerLink.ID,
                Name: linkedServer.ServerLink.ExternalName,
            })

        })

        console.log(externalServers)

        return externalServers
    }

    render(){

        let gridWrapperStyle = {
            height:'83%', 
            //borderTop:'1px solid '+theme.palette.border.dialog
        }

        let gridLeftStyle = {}
        let gridRightStyle = {}

        return (

            <Grid container key="1" justifyContent="flex-start" spacing={0} style={gridWrapperStyle} >
                    <Grid xs={5} item style={gridLeftStyle}>

                        <LocalGroupsList 
                            serverSettings={this.props.serverSettings}
                            //loadExternalGroups={this.props.loadExternalGroups}
                            
                            onAction={this.props.onAction}
                        />

                    </Grid>
                    <Grid xs={7} item style={gridRightStyle}>

                        <ExternalGroupsList
                            serverSettings={this.props.serverSettings}
                            localGroupID={this.props.selectedLocalGroup ? this.props.selectedLocalGroup.groupID : null}
                            localNetworkID={this.props.selectedLocalGroup ? this.props.selectedLocalGroup.networkID : null}

                            externalGroups={this.getExternalGroupsList(
                                this.props.serverSettings,
                                this.props.selectedLocalGroup ? this.props.selectedLocalGroup.networkID : null,
                                this.props.selectedLocalGroup ? this.props.selectedLocalGroup.groupID : null
                            )}

                            externalServers={this.getExternalServers(this.props.serverSettings)}

                            onAction={this.props.onAction}
                        />
                        

                    </Grid>
            </Grid>


        )

    }

}



export const ServerLinks = withTranslation()(ServerLinks_);